// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"product-grid_productGrid__z4OUy","loading":"product-grid_loading__AgwF_","loading__dark":"product-grid_loading__dark__Khirs"};